import { Component, Input } from '@angular/core';

export interface BreadcrumbItem {
  label: string;
  url?: string;
}

@Component({
  selector: 'app-afiliado-breadcrumb',
  templateUrl: './afiliado-breadcrumb.component.html',
  styleUrls: ['./afiliado-breadcrumb.component.scss']
})
export class AfiliadoBreadcrumbComponent {
  @Input() items: BreadcrumbItem[] = [];
}
